import React from 'react';
import './TodoSearch.css'

function TodoSearch({ searchValue, setSearchValue, loading }) {
  const onSearchValueChange = (event) => { 
    setSearchValue(event.target.value); 
  };

  return (
    <input
      id="TodoSearch"
      className="TodoSearch"
      placeholder="Buscar una tarea"
      value={searchValue}
      onChange={onSearchValueChange}
      disabled={loading}
    />
  );
}

export { TodoSearch };